var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-center"},[_c('div',{staticClass:"sm__tag mx-1 my-auto"}),_c('sm-text',{attrs:{"format":"sm__h4","text":_vm.label,"color":"black"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }